import { MtUser, MtAccount } from "server/models"
import { OrderType } from "client/utils"
import { UserFilters, AccountFilters } from "client/store"


export interface AccountUserList { [accountId: number]: readonly number[]}
export interface UserAccountList { [userId: number]: readonly number[]}

export interface AccountUserState {
    accountUserList: AccountUserList
    userAccountList: UserAccountList

    assignedUsers: {
        userIds: readonly number[]
        sortColumn: keyof MtUser
        sortOrder: OrderType
        filters: UserFilters
    }
    notAssignedUsers: {
        userIds: readonly number[]
        sortColumn: keyof MtUser
        sortOrder: OrderType
        filters: UserFilters
        selected: readonly number[]
    }

    assignedAccounts: {
        accountIds: readonly number[]
        sortColumn: keyof MtAccount
        sortOrder: OrderType
        filters: AccountFilters
    }
    notAssignedAccounts: {
        accountIds: readonly number[]
        sortColumn: keyof MtAccount
        sortOrder: OrderType
        filters: AccountFilters
        selected: readonly number[]
    }

    reloadAccountUserList: boolean
    reloadUserAccountList: boolean
}

export const ACCOUNT_USER_LIST = "ACCOUNT_USER_LIST"
export const USER_ACCOUNT_LIST = "USER_ACCOUNT_LIST"

export const ASSIGNED_ACCOUNT_USER_IDS = "ASSIGNED_ACCOUNT_USER_IDS"
export const ASSIGNED_ACCOUNT_USER_SORT = "ASSIGNED_ACCOUNT_USER_SORT"
export const ASSIGNED_ACCOUNT_USER_FILTERS = "ASSIGNED_ACCOUNT_USER_FILTERS"

export const NOT_ASSIGNED_ACCOUNT_USER_IDS = "NOT_ASSIGNED_ACCOUNT_USER_IDS"
export const NOT_ASSIGNED_ACCOUNT_USER_SORT = "NOT_ASSIGNED_ACCOUNT_USER_SORT"
export const NOT_ASSIGNED_ACCOUNT_USER_FILTERS = "NOT_ASSIGNED_ACCOUNT_USER_FILTERS"
export const NOT_ASSIGNED_ACCOUNT_USER_SELECTED = "NOT_ASSIGNED_ACCOUNT_USER_SELECTED"

export const ASSIGNED_USER_ACCOUNT_IDS = "ASSIGNED_USER_ACCOUNT_IDS"
export const ASSIGNED_USER_ACCOUNT_SORT = "ASSIGNED_USER_ACCOUNT_SORT"
export const ASSIGNED_USER_ACCOUNT_FILTERS = "ASSIGNED_USER_ACCOUNT_FILTERS"

export const NOT_ASSIGNED_USER_ACCOUNT_IDS = "NOT_ASSIGNED_USER_ACCOUNT_IDS"
export const NOT_ASSIGNED_USER_ACCOUNT_SORT = "NOT_ASSIGNED_USER_ACCOUNT_SORT"
export const NOT_ASSIGNED_USER_ACCOUNT_FILTERS = "NOT_ASSIGNED_USER_ACCOUNT_FILTERS"
export const NOT_ASSIGNED_USER_ACCOUNT_SELECTED = "NOT_ASSIGNED_USER_ACCOUNT_SELECTED"

export const ACCOUNT_USER_RELOAD_LIST = "ACCOUNT_USER_RELOAD_LIST"
export const USER_ACCOUNT_RELOAD_LIST = "USER_ACCOUNT_RELOAD_LIST"
